<template>
  <div class="row">
    <div class="col-lg-8 col-xl-9 order-lg-1">
      <app-frame>
        <lazy-player :id="`hero-${video.id}`" :video="video" :poster="getFreeareaVideoPoster(video.thumb)" />
      </app-frame>
      <div class="video-label" v-html="t(`In our journey we've met <b>892 models</b>, made <b>6390+ videos</b> and had countless orgasms`)" />
    </div>
    <div class="description-block col-lg-4 col-xl-3 order-lg-0">
      <h1 class="main-title">
        {{ video[`title_${locale}`] }}
      </h1>
      <p>{{ video[`hero_description_${locale}`] }}</p>

      <div class="d-flex justify-content-center justify-content-lg-start">
        <button v-modal.modal-signup class="btn btn-primary wide hero-join" @click="sendRegistrationTrack">
          {{ ctaLabel || t("Join Now") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from "vue";
import { useI18n } from "vue-i18n";
import AppFrame from "@/components/v2/app-frame/index.vue";
import { amplitudeRegistrationButtonClickTrack } from "@/utils/amplitude";
import { FreeareaVideo } from "@/interfaces/Video/FreeareaVideo.ts";
import LazyPlayer from "@/components/lazy-player/index.vue";
import { getFreeareaVideoPoster } from "@/utils/mediaHelper.ts";

defineOptions({
  name: "hero-item",
});

defineProps({
  video: {
    type: Object as PropType<FreeareaVideo>,
    required: true,
  },
  ctaLabel: {
    type: String,
    required: false,
    default: null,
  },
});

const { locale, t } = useI18n();

const sendRegistrationTrack = () => {
  amplitudeRegistrationButtonClickTrack("hero");
};
</script>
